import {
  faCheckCircle,
  faTimesCircle,
  faPauseCircle,
  faQuestionCircle,
  faWarning
} from '@fortawesome/free-solid-svg-icons';

import { ERROR_RED_COLOR, SUCCESS_GREEN_COLOR, WARNING_ORANGE_COLOR } from '@/constants/color';
import { isInsurancePolicyExpired } from '@/pages/Profile/utils/isInsurancePolicyExpired';
import IconItem from '@/ui/components/IconItem';
import Tooltip from '@/ui/components/Tooltip';
import UnknownIconItem from '@/ui/components/UnknownIconItem';

import { Props, PaymentMethod } from './types';

const PaymentRow = ({ payment_type, insurance, insuranceIneligible }: Props) => {
  const { has_active_treatability_match, is_in_network, is_waitlisted, plan_end_date } =
    insurance || {};

  let color;
  let icon;
  let tooltip;
  if (
    PaymentMethod.SELF_PAY === payment_type ||
    PaymentMethod.RESEARCH === payment_type ||
    PaymentMethod.FREE_TRIAL === payment_type
  ) {
    icon = faCheckCircle;
    color = SUCCESS_GREEN_COLOR;
  } else if (payment_type === PaymentMethod.INSURANCE) {
    if (isInsurancePolicyExpired(plan_end_date)) {
      icon = faWarning;
      color = ERROR_RED_COLOR;
      tooltip = 'This insurance plan has expired';
    } else if (!has_active_treatability_match && is_in_network) {
      icon = faWarning;
      color = WARNING_ORANGE_COLOR;
      tooltip = "We accept this insurance, but it is not eligible for the member's program";
    } else if (is_in_network) {
      icon = faCheckCircle;
      color = SUCCESS_GREEN_COLOR;
      tooltip = 'We accept this insurance';
    } else if (is_waitlisted) {
      icon = faPauseCircle;
      color = 'text-orange-500';
      tooltip = 'We are currently waitlisting this insurance';
    } else if (insuranceIneligible) {
      icon = faTimesCircle;
      color = ERROR_RED_COLOR;
      tooltip = 'We do not accept this insurance';
    } else {
      icon = faQuestionCircle;
      color = 'text-yellow-500';
      tooltip = 'We are missing data about this insurance';
    }
  } else {
    icon = faQuestionCircle;
    color = 'text-yellow-500';
    tooltip = `Unknown payment type: ${payment_type}`;
  }

  if (!payment_type) {
    return (
      <UnknownIconItem>
        <a className="text-blue-600" href="#program-qualification-section">
          No payment type
        </a>
      </UnknownIconItem>
    );
  }

  return (
    <Tooltip disabled={!tooltip} tooltipContent={tooltip}>
      <span>
        <IconItem icon={icon} color={color}>
          <a className="text-blue-600" href="#program-qualification-section">
            Payment:{' '}
          </a>
          {payment_type}
        </IconItem>
      </span>
    </Tooltip>
  );
};

export default PaymentRow;
